import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "recent-trade-feed-wrapper",
  class: "summary-card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "최근 실거래 피드", -1)
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "불러오는 중...", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "거래 데이터가 없습니다.", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "feed-list"
}
const _hoisted_10 = { class: "feed-date" }
const _hoisted_11 = { class: "feed-info" }
const _hoisted_12 = { class: "feed-apt" }
const _hoisted_13 = { class: "feed-area" }
const _hoisted_14 = { class: "feed-amount" }
const _hoisted_15 = { class: "feed-gu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (_ctx.trades.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trades, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "feed-item"
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.dealYear) + "." + _toDisplayString(String(item.dealMonth).padStart(2, '0')) + "." + _toDisplayString(String(item.dealDay).padStart(2, '0')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.aptNm), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item.excluUseAr) + "㎡ / " + _toDisplayString(item.floor) + "층", 1)
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString((item.dealAmount / 10000).toFixed(1)) + "억", 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(item.umdNm), 1)
              ]))
            }), 128))
          ]))
  ]))
}